<template>
  <div class="Lightbox" id="RuleBox">
    <div @click="close" class="LightboxOverlay"></div>
    <div class="LightboxWrap">
      <div class="Content">
        <div class="Titlebar">
          <h3>選擇此商品</h3>
          <div class="BtnClose">
            <a @click="close" class="Close">Close</a>
          </div>
        </div>
        <div class="DetailBox" :style="calacScrollHeight">
          <div v-if="showSpecBox" class="DetailRow">
            <div class="LabelName">商品規格</div>
            <div class="StyleList">
              <a @click="changeNowSpec(item.id, index)" v-for="(item, index) of info.variants" :key="index"
                :class="{ Activity: nowSelectedSpec === item.id, NoStore: item.isSoldOut }" :title="item.name">{{
      item.name
    }}</a>
            </div>
          </div>
          <div class="Flex">
            <div class="LabelName">數量</div>
            <div class="Quantity">
              <button @click="minus()" class="IconMin"></button>
              <input type="text" :value="cartBuyQuantity" class="QuantityNum" readonly="true" />
              <button @click="plus()" class="IconPlus"></button>
            </div>
          </div>

          <buyadditional v-if="showAdditional" :items="info.additional" v-on:sendAdditional="getAdditional" />
        </div>
        <div class="ButtonBar">
          <a @click.stop.prevent="goShop()" title="立即購買" class="Btn">
            <i class="IconCar"></i>立即購買
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import buyadditional from "./buyadditional";
export default {
  name: "buyitem",
  data() {
    return {
      cartData: [],
      info: {},
      showAdditional: false,
      showSpecBox: false,
      nowSelectedSpec: null,
      nowSelectedSpecIdx: 0,
      nowSelectedSpecName: "",
      cartBuyQuantity: 1,
      cartAdditional: [],
      lightboxWrapTop: 0,
    };
  },
  props: {
    pid: {
      type: Number,
      required: true,
    },
    defaultQty: {
      type: Number,
      default: () => 1
    }
  },
  updated() { },
  mounted() { },
  computed: {
    calacScrollHeight() {
      return {
        "max-height": this.isMobile ? window.innerHeight - 182 + "px" : "500px",
      };
    },
  },
  created() {
    const cacheName = `baseshop_product_detail_${this.pid}`;
    const cache = this.storage.get(cacheName, true);
    if (cache) {
      this.info = cache;
      this.parseProductDetail();
    } else {
      fetch(`${this.configs.frontCloudApiPath()}product/v3/${this.pid}`)
        .then(res => res.json())
        .then(res => {
          const data = res.resultData;
          this.info = data;
          this.parseProductDetail();
          this.storage.set(cacheName, data, this.configs.webCacheExpireTime, true);
        });
    }
    this.cartBuyQuantity = this.defaultQty;
  },
  methods: {
    parseProductDetail() {
      for (let i in this.info.variants) {
        if (!this.info.variants[i].isSoldOut) {
          this.nowSelectedSpec = this.info.variants[i].id;
          this.nowSelectedSpecIdx = parseInt(i);
          this.nowSelectedSpecName = this.info.variants[i].name;
          break;
        }
      }
      if (this.info.variants.length > 1) {
        this.showSpecBox = true;
      }
      if (this.info.additional && this.info.additional.length > 0) {
        this.showAdditional = true;
        this.$emit('hasAdditional', this.info);
      }

      this.$emit("setCartType", this.info.cart_type);
    },
    changeNowSpec(id, idx) {
      if (!this.info.variants[idx].isSoldOut) {
        this.nowSelectedSpecIdx = idx;
        this.cartBuyQuantity = 1;
        this.nowSelectedSpec = id;
        this.nowSelectedSpecName = this.info.variants[idx].name;
      }
    },
    close() {
      this.$emit("closeBuyItem");
    },
    minus() {
      this.cartBuyQuantity =
        this.cartBuyQuantity === 1 ? 1 : (this.cartBuyQuantity -= 1);
    },
    plus() {
      const ele = this.info.variants[this.nowSelectedSpecIdx];
      const purchase_qty = ele.qtyMax === 999 ? ele.qty : ele.qtyMax;
      this.cartBuyQuantity =
        this.cartBuyQuantity < purchase_qty ?
          (this.cartBuyQuantity += 1) :
          purchase_qty;
    },
    goShop() {
      // 追蹤碼設定
      const chaId = document.cookie.match(/CHANNEL_ID0=([^;]+)/i);
      let channelId;
      if (chaId && chaId[1] && chaId[1] !== 'fetmc_appbonus') {
        channelId = chaId[1];
      }

      const o = this.info;
      let apiPayload = {
        channelId3: channelId,
        productId: o.pid,
        pageId: o.pageId,
        pageType: o.pageType,
        quantity: +this.cartBuyQuantity,
        skuId: +o.skuId
      };
      this.$emit("addToCart", apiPayload);
    },
    getAdditional(data) {
      this.cartAdditional = data;
    },
  },
  components: {
    buyadditional,
  },
};
</script>

<style lang="scss" scoped>
#RuleBox {
  .LightboxWrap {
    max-width: 460px;
    height: auto;
    max-height: 690px;
    min-height: 300px;
  }

  .ButtonBar {
    margin: 0;
    position: absolute;
    left: 0;
    right: 0;
    padding-top: 3%;
    border-top: 1px solid #e0e0e0;
    padding: 2%;
    bottom: 0;
    background-color: #fff;
    border-radius: 0 0 10px 10px;
    cursor: pointer;
  }
}

.StyleList {
  a {
    display: inline-block;
    padding: 1% 3%;
    background-color: #f4f4f4;
    color: #adadad;
    margin-right: 5px;
    border-radius: 8px;
    margin-bottom: 5px;
  }

  a.Activity {
    background-color: #f34f59;
    color: #fff;
  }

  a.NoStore {
    background-color: #f4f4f4;
    color: #e0e0e0;
    cursor: default;
  }
}

@media (max-width: 768px) {
  #RuleBox {
    .LightboxWrap {
      bottom: 0;
      position: inherit;
      width: 100%;
      max-width: 100%;
      border-radius: inherit;
      max-height: 90vh;
    }
  }
}
</style>
